(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8227],{

/***/ 27772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-results/[idLocation]",
      function () {
        return __webpack_require__(41228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var blocks_search_bar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42742);
/* harmony import */ var blocks_Layouts_GlobalLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94082);
/* harmony import */ var blocks_TravelSearchResults_TravelSearchResults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5870);






var GeneralSearchResultsPage = function(param) {
    var globalLayoutProps = param.globalLayoutProps, searchResults = param.searchResults, inspirations = param.inspirations, initialSearchValue = param.initialSearchValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(blocks_Layouts_GlobalLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(blocks_search_bar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                inspirations: inspirations,
                initialSearchValue: initialSearchValue
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(blocks_TravelSearchResults_TravelSearchResults__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                searchResults: searchResults
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (GeneralSearchResultsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,7295,5901,1608,5156,1657,1736,2567,6492,2334,2083,9565,4520,5989,2394,2742,5870,9774,2888,179], function() { return __webpack_exec__(27772); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);